import React from 'react';

import { useTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react';

import gtmTracker from '@utils/gtmTracker';

import useEnglishTranslation from '@hooks/use-english-translation';

import { Slider } from '@components/slider';

import { config } from '@/config.ts';

import * as Styled from './mobile-nav.styled';
import { getNavListForBrand } from '../../nav-config';

type OwnProps = {
	isAuthenticated?: boolean;
};

const MobileNav: React.FC<OwnProps> = ({ isAuthenticated }) => {
	const navList = getNavListForBrand(config.BRAND, isAuthenticated);
	const { t } = useTranslation('main');
	const tEn = useEnglishTranslation('main');

	const handleMenuClick = (label: string) => {
		gtmTracker.trackEvent('click', {
			event_category: 'Menu',
			event_action: 'click',
			event_label: label
		});
	};

	return (
		<Styled.Wrapper>
			<Styled.NavContainer>
				<Slider navigation={false} pagination={false} spaceBetween='8px' slidesPerView='auto'>
					{navList.map((nav, index) => {
						return nav.onlyLoggedIn ? (
							isAuthenticated && (
								<SwiperSlide key={nav.key} virtualIndex={index}>
									<Styled.LinkStyled to={nav.path} onClick={() => handleMenuClick(tEn(nav.labelKey))}>
										{t(nav.labelKey)}
									</Styled.LinkStyled>
								</SwiperSlide>
							)
						) : (
							<SwiperSlide key={nav.key} virtualIndex={index}>
								<Styled.LinkStyled to={nav.path} onClick={() => handleMenuClick(tEn(nav.labelKey))}>
									{t(nav.labelKey)}
								</Styled.LinkStyled>
							</SwiperSlide>
						);
					})}
				</Slider>
			</Styled.NavContainer>
		</Styled.Wrapper>
	);
};

export default MobileNav;
